const ENDPOINT = 'GETartistprofile';
function getArtistProfile(gateway, params = {}, customURL = null, customHeaders = null, isKoussa = false) {
    return gateway.get(getArtistProfile.endpoint, params, customURL, customHeaders, isKoussa);
}
getArtistProfile.endpoint = ENDPOINT;

export { getArtistProfile as default };
//# sourceMappingURL=getArtistProfile.js.map
